import { format, parseISO, isValid } from 'date-fns';
import { SMS } from '../../utils/constants';

export const makeGetRecipientsCount = (values, message) => messageType => {
  if (messageType === SMS && values.sendSms === false) return 0;

  switch (values.targetedUsers) {
    case 'all':
      return message[`allUser${messageType}RecipientCount`];
    case 'active':
      return message[`activatedUser${messageType}RecipientCount`];
    case 'inactive':
      return message[`inactiveUser${messageType}RecipientCount`];
    case 'not_participated':
      return message[`notParticipatedUser${messageType}RecipientCount`];
    default:
      return 0;
  }
};

export const formatDate = (date, time, timezone) => {
  const parsedDate = parseISO(date);
  if (isValid(parsedDate)) {
    return `${format(parsedDate, 'ccc MM/dd/yy')} at ${time} ${timezone}`;
  }

  return '';
};
